import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { Carousel } from 'primeng/carousel'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  styles: [],
})
export class AppComponent {
  title = 'bot-yako'
  constructor() {
    Carousel.prototype.onTouchMove = () => {}
  }
}
